import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import { Button } from '@material-ui/core';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';

interface IAttributesTopBar {
  onNewAttribute: () => void,
}

const AttributesTopBar = ({ onNewAttribute }: IAttributesTopBar) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <div className={classes.barStyle}>
        <div className={classes.whiteSpace} />
        <Button 
          variant="outlined" 
          startIcon={<AddIcon />} 
          className={classes.buttonStyle}
          onClick={onNewAttribute}
        >
          {t("attributes.button.new")}
        </Button>
      </div>
    </div>
  );
};

export default AttributesTopBar;
